export enum EnvType {

    Web = "web",
    Native = "native",
    Electron = "electron",
}
